import { CardHistoryReturnOrder } from '@/entities/profile-page/returnOrders/CardHistoryReturnOrder/ui/CardHistoryReturnOrder'
import './ui/CardHistoryReturnOrder.scss'
export default CardHistoryReturnOrder
